{
  "version": 1,
  "asset_id": "ad4bbb03-ef56-4e41-9f0f-03b4b01ed681",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/ad4bbb03-ef56-4e41-9f0f-03b4b01ed681/hiatal-type-3-story-hernia-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/ad4bbb03-ef56-4e41-9f0f-03b4b01ed681/hiatal-type-3-story-hernia-800.webp",
  "original_filename": "hiatal-type-3-story-hernia-800.webp",
  "size": 40662,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:16Z"
}
